(function () {

  'use strict';

  function pxLegalDocuments($filter, toastr) {
    return {
      restrict: 'EA',
      scope: {
        tenant: '=tenant',
        me: '=me'
      },
      templateUrl: 'app/components/subscription/legalDocuments/legalDocuments.template.html',
      link: function (scope) {

        scope.termsOfService = undefined;
        scope.showTermsOfServiceDialog = false;

        scope.openTermsOfServiceDialog = function () {
          scope.showTermsOfServiceDialog = true;
        };

        scope.closeTermsOfServiceDialog = function () {
          scope.showTermsOfServiceDialog = false;
        };

        (function () {
          getTermsOfService();
        })();

        function getTermsOfService() {
          scope.tenant.getTermsOfService()
            .then(function (termsOfService) {
              scope.termsOfService = termsOfService;
              if (!scope.termsOfService.content) {
                toastr.error($filter('translate')('TermsOfServiceLoadError'));
              }
            })
            .catch(function (response) {
              toastr.error($filter('translate')('TermsOfServiceLoadError'));
            });
        }

      }
    };
  }

  pxLegalDocuments.$inject = ['$filter', 'toastr'];

  angular
    .module('printix-admin')
    .directive('pxLegalDocuments', pxLegalDocuments);

})();
